import { render, staticRenderFns } from "./SidebarNavigation.vue?vue&type=template&id=44c5fe47&scoped=true&"
import script from "./SidebarNavigation.vue?vue&type=script&lang=js&"
export * from "./SidebarNavigation.vue?vue&type=script&lang=js&"
import style0 from "./SidebarNavigation.vue?vue&type=style&index=0&id=44c5fe47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c5fe47",
  null
  
)

export default component.exports